import React from 'react'
import SalaryRow from '../components/salary/salaryRow.component'

import {
  GET_NEW_SALARY_SUCCESS,
  SELECT_ROW_SALARY,
  SELECT_ROW_SALARY_SUCCESS,
  GET_SALARIES_SUCCESS,
  GET_SALARY_BY_ID_SUCCESS,
  SALARY_PAGE_CHANGE,
  ADD_SALARY_SUCCESS,
  LOCATION_CHANGE,
  WARN_TO_ADD_COST,
  CANCEL_PAY_SALARY,
  POST_SALARY,
  WARN_NO_SSN,
  ADD_SALARY_FAILURE,
  CLOSE_SALARY_PAY_ERROR,
  CLEAR_SALARY_SELECTION,
  GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS,
  CLOSE_DIALOG_SALARY,
  SEND_REFERRAL_CODE_SUCCESS,
  SEND_REFERRAL_CODE_FAILED,
  CLOSE_SALARY_SNACKBAR,
  CLEAR_SELECTED_USER,
  STANDARD_VAT_CALCULATION_INDEX
} from '../constants/index'

import DateTimeFormat from '../utils/DateTimeFormat'
import { convertNameToState } from '../utils/invoice.utils'

const initialState = {
  newSalary: [],
  selectedRows: [],
  salaryAllowances: [],
  salaryRows: [],
  allSalaries: [],
  selected: 0,
  newSalaryInfo: [],
  newSalarySummary: {
    sumInvWithoutTax: 0,
    sumWithTax: 0,
    service_cost: 12,
    salary_sum: 0,
    gross_sum: 0,
    net_sum: 0,
    isnormalgovpay: false,
    isbruttogovpay: false,
    normal_ulosotto_sum: 0,
    brutto_ulosotto_sum: 0,
    allowances_cost: 0,
    expenses_cost: 0,
    paid_sum: 0,
    status: 0,
    instant_payment: [],
    isPartial: 0,
    isGroupInvoice: 0
  },
  salaryTaxPercentage: [],
  isSalaryInfo: false,
  isToAdd: false,
  isNoSSN: false,
  salaryPayError: false,
  showDialog: false,
  willGetDiscount: false, // Will get the discount after activate the referral code
  recommendedPersonGetDiscount: false,
  referrerPersonGetDiscount: false,
  discount: false,
  sendCodeSuccess: false,
  sendCodeFailed: false,
  nerverUseDiscount: false,
  isCodeActivated: false,
  accountStatus: '' // KAS-385 Referral bug to check user status
}

const salaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NEW_SALARY_SUCCESS:
      return Object.assign({}, { ...state }, { newSalary: action.result })

    case GET_SALARIES_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          allSalaries: action.resultParsed,
          salaryRows: _createSalaryRows(action.resultParsed, state.selected)
        }
      )

    case SALARY_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          salaryRows: _createSalaryRows(
            state.allSalaries,
            action.selected.selected
          ),
          selected: action.selected.selected
        }
      )

    case SELECT_ROW_SALARY:
      return Object.assign(
        {},
        { ...state },
        {
          selectedRows: _handleSalaryRowClick(
            action.selected,
            state.selectedRows
          ),
          isSalaryInfo: false
        }
      )

    case CLEAR_SALARY_SELECTION:
      return Object.assign(
        {},
        { ...state },
        {
          newSalarySummary: {
            sumInvWithoutTax: 0,
            sumWithTax: 0,
            service_cost: 12,
            salary_sum: 0,
            gross_sum: 0,
            net_sum: 0,
            isnormalgovpay: false,
            isbruttogovpay: false,
            normal_ulosotto_sum: 0,
            brutto_ulosotto_sum: 0,
            allowances_cost: 0,
            expenses_cost: 0,
            paid_sum: 0,
            instant_payment: [],
            isPartial: 0
          },
          selectedRows: [],
          salaryAllowances: [],
          salaryTaxPercentage: []
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selectedRows: [],
          showDialog: false,
          willGetDiscount: false,
          recommendedPersonGetDiscount: false,
          referrerPersonGetDiscount: false,
          sendCodeSuccess: false,
          sendCodeFailed: false,
          nerverUseDiscount: false,
          isCodeActivated: false
        }
      )

    case ADD_SALARY_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          selectedRows: []
        }
      )

    case ADD_SALARY_FAILURE:
      return Object.assign(
        {},
        { ...state },
        {
          salaryPayError: true
        }
      )

    case CLOSE_SALARY_PAY_ERROR:
      return Object.assign(
        {},
        { ...state },
        {
          salaryPayError: false
        }
      )

    case WARN_TO_ADD_COST:
      return Object.assign(
        {},
        { ...state },
        {
          isToAdd: true
        }
      )

    case WARN_NO_SSN:
      return Object.assign(
        {},
        { ...state },
        {
          isToAdd: false,
          isNoSSN: true
        }
      )

    case CANCEL_PAY_SALARY:
      return Object.assign(
        {},
        { ...state },
        {
          isToAdd: false,
          isNoSSN: false
        }
      )

    case POST_SALARY:
      return Object.assign(
        {},
        { ...state },
        {
          isToAdd: false
        }
      )

    case GET_SALARY_BY_ID_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          newSalaryInfo: action.result,
          isSalaryInfo: true
        }
      )

    case SELECT_ROW_SALARY_SUCCESS:
      const salaryTaxPercent = action.result.taxResult
      let service_percentage = salaryTaxPercent[0].service_payment
      const standard_social_tax = salaryTaxPercent[0].standard_social_tax
      const yel_option = salaryTaxPercent[0].yelselect
      const total_gross = salaryTaxPercent[0].Totalgross
      const yel_percentage = salaryTaxPercent[0].yel_percentage * 0.01
      let yel_income = salaryTaxPercent[0].yel_income
      const personal_tax_percentage = salaryTaxPercent[0].tax_percentage * 0.01
      const normal_ulosotto = salaryTaxPercent[0].isnormalgovpay
      const brutto_ulosotto = salaryTaxPercent[0].isbruttogovpay
      let sumWithTaxComb = state.selectedRows.reduce(
        (a, b) =>
          a + state.newSalary[b].sumwithoutTax + state.newSalary[b].sumVat,
        0
      )
      sumWithTaxComb = Math.round(sumWithTaxComb * 100) / 100

      const inv_status = state.selectedRows.map(
        (el) => state.newSalary[el].status
      )

      const inv_partialStatus = state.selectedRows.map(
        (el) => state.newSalary[el].isPartial
      )

      // invoice items VAT 0, allowance VAT 0 and expense with VAT
      // Starting sum for calculation
      // sumInvWithTax: total invoice amount with VAT
      // sumInvVat: VAT from invoice items
      // suminvAllowVat: VAT from allowances
      // after calculation, it returns pay roll start amount
      // inv_sum = pay roll start amount

      const inv_sum = state.selectedRows.map((el) =>
        // KAS-553,554 When the selected is group invoice, take "sumVat" for calculation instead of "sumIvnVat"
        state.newSalary[el].isGroupInvoice !== 1
          ? state.newSalary[el].sumInvWithTax -
            state.newSalary[el].sumInvVat -
            state.newSalary[el].suminvAllowVat
          : state.newSalary[el].sumInvWithTax -
            state.newSalary[el].sumVat -
            state.newSalary[el].suminvAllowVat
      )

      // inv_sum alternative fomula
      // When there is expenses and allowances attached externally, it will be included
      // Use this when calculate service fees for expenses and allowances attached externally
      const inv_sum_alternative_fomula = state.selectedRows.map((el) =>
        state.newSalary[el].isGroupInvoice !== 1
          ? state.newSalary[el].sumInvWithoutTax +
            state.newSalary[el].expenses +
            state.newSalary[el].allowances
          : state.newSalary[el].sumwithoutTax +
            state.newSalary[el].expenses +
            state.newSalary[el].allowances
      )

      // console.log(
      //   'huong inv_sum_alternative_fomula [] >>>>>>>>>>>>>>>>>>>>>>>>>>',
      //   inv_sum_alternative_fomula
      // )

      const quick_pay_percentage = salaryTaxPercent[0].quick_pay_percentage

      const inst_pay = state.selectedRows.map(
        (el) => state.newSalary[el].instant_payment
      )
      const inst_pay_final = []
      for (var i = 0; i < inst_pay.length; i++) {
        if (inst_pay[i] === 'quick_pay') {
          inst_pay_final.push(quick_pay_percentage)
        } else {
          inst_pay_final.push(0)
        }
      }

      // Group invoice
      const group_invoice = state.selectedRows.map(
        (el) => state.newSalary[el].isGroupInvoice
      )

      const ser_per_final = []
      for (var i = 0; i < inst_pay_final.length; i++) {
        ser_per_final.push(inst_pay_final[i])
      }

      // This payroll start amount in the specific scenario will also deduct the external allowances and expenses attached
      const payRollStartAmount_value = state.selectedRows.map((el) => {
        if (state.newSalary[el].isGroupInvoice !== 1) {
          return (
            state.newSalary[el].sumInvWithTax -
            state.newSalary[el].sumInvVat -
            state.newSalary[el].suminvAllowVat -
            state.newSalary[el].expenses -
            state.newSalary[el].allowances
          )
        } else {
          // Group invoice
          return (
            state.newSalary[el].sumInvWithTax -
            state.newSalary[el].sumVat -
            state.newSalary[el].suminvAllowVat -
            state.newSalary[el].expenses -
            state.newSalary[el].allowances
          )
        }
      })
      // let payRollStartAmount = payRollStartAmount_value.reduce(
      //   (a, b) => a + b,
      //   0
      // )

      // Invoice items without vat (excluding allowance and expense)
      // Incase it's an allowance or expense only invoice, this will be 0
      // This is the normal invoice item without vat
      let payRollStartAmount_invoice_item_without_vat =
        state.selectedRows.reduce(
          (a, b) =>
            state.newSalary[b].isGroupInvoice !== 1
              ? a + state.newSalary[b].sumInvWithoutTax
              : // KAS-553,554 When the selected is group invoice, take "sumwithoutTax" for calculation instead of "sumInvWithoutTax"
                a + state.newSalary[b].sumwithoutTax,
          0
        )
      // KAS-336 Referral program discount -> service_cost or palvelu_final is 0 eur
      // Instead of setting service_cost or palvelu to 0 after gross.
      // Pushing ser_cost and pavelu arrays with 0 to calculate with them before gross.
      const discount =
        ((state.recommendedPersonGetDiscount &&
          payRollStartAmount_invoice_item_without_vat >= 500) ||
          state.referrerPersonGetDiscount) &&
        inst_pay[0] !== 'quick_pay' &&
        !group_invoice[0] &&
        state.selectedRows.length === 1
          ? true
          : false

      const ser_cost = []
      if (discount) {
        for (var i = 0; i < inv_sum.length; i++) {
          ser_cost.push(0)
        }
      } else {
        for (var i = 0; i < inv_sum.length; i++) {
          ser_cost.push(
            inv_sum[i] *
              ser_per_final[i] *
              0.01 *
              STANDARD_VAT_CALCULATION_INDEX +
              // inv_sum[i] * service_percentage * 0.01
              // Because we will deduct normal service fee of expenses and allowances attached externally
              // Then we need to use inv_sum_alternative_fomula
              inv_sum_alternative_fomula[i] * service_percentage * 0.01
          )
        }
      }

      // console.log('huong ser cost [] >>>>>>>>>>>>>>>>>>>>>>...', ser_cost)

      const payRollStartAmount_invoice_item_without_vat_per_invoice =
        state.selectedRows.map((el) => {
          if (state.newSalary[el].isGroupInvoice !== 1) {
            return state.newSalary[el].sumInvWithoutTax
          } else {
            // Group invoice
            return state.newSalary[el].sumwithoutTax
          }
        })
      // console.log(
      //   'huong payRollStartAmount_invoice_item_without_vat_per_invoice [] >>>>>>>>>>>>>>>>>>>>>>...',
      //   payRollStartAmount_invoice_item_without_vat_per_invoice
      // )

      let service_cost = ser_cost.reduce((a, b) => a + b, 0)
      //Removed VAT from Service Percentage
      // palvelu: standard service fee
      // Palvelu is the normal service fees is shown at UI
      // Palvelu = normal service fees + allowances and expenses service fees (if any)
      const palvelu = []
      if (discount) {
        for (var i = 0; i < inv_sum_alternative_fomula.length; i++) {
          palvelu.push(0)
        }
      } else {
        for (var i = 0; i < inv_sum_alternative_fomula.length; i++) {
          palvelu.push(
            inv_sum_alternative_fomula[i] * service_percentage * 0.01
          )
        }
      }

      // When allowances and expenses are in the invoice rows
      // Allowance Expense Service Cost Higher Than Invoice Items
      // This is the remaining service_cost amount
      for (
        var i = 0;
        i < payRollStartAmount_invoice_item_without_vat_per_invoice.length;
        i++
      ) {
        if (
          payRollStartAmount_invoice_item_without_vat_per_invoice[i] <
            ser_cost[i] &&
          payRollStartAmount_invoice_item_without_vat_per_invoice[i] !== 0
        ) {
          palvelu[i] =
            payRollStartAmount_invoice_item_without_vat_per_invoice[i]
        }
      }
      // console.log('huong palvelu [] >>>>>>>>>>>>>>>>>>>>>>...', palvelu)

      let palvelu_final = palvelu.reduce((a, b) => a + b, 0)
      palvelu_final = Math.round(palvelu_final * 100) / 100

      const pikapalkka = []
      for (var i = 0; i < inv_sum.length; i++) {
        pikapalkka.push(
          inv_sum[i] * inst_pay_final[i] * 0.01 * STANDARD_VAT_CALCULATION_INDEX
        )
      }
      let pikapalkka_final = pikapalkka.reduce((a, b) => a + b, 0)
      pikapalkka_final = Math.round(pikapalkka_final * 100) / 100

      //expense_cost_with_vat
      const expense_with_vat = state.selectedRows.map(
        (el) => state.newSalary[el].expenses
      )
      //Expense cost without vat
      const expense_cost_with_vat = expense_with_vat.reduce((a, b) => a + b, 0)

      const expense_without_vat = state.selectedRows.map(
        (el) => state.newSalary[el].expense_cost_without_vat
      )
      const expense_cost_without_vat = expense_without_vat.reduce(
        (a, b) => a + b,
        0
      )

      const expense = state.selectedRows.map(
        (el) => state.newSalary[el].expenses
      )
      const allowance = state.selectedRows.map(
        (el) => state.newSalary[el].allowances
      )

      const social_tax = []
      // No yel, don't calculate social contribution.
      if (yel_option === 'no_yel') {
        for (var i = 0; i < inv_sum.length; i++) {
          social_tax.push(0)
        }
      } else {
        // Checking if there are expenses or allowances
        // and calculating the social contribution
        for (var i = 0; i < inv_sum.length; i++) {
          let social_tax_value

          if (0 < expense[i] && 0 < allowance[i]) {
            // Calculating the social fee per §kho 2023:42
            /**
             * Salary KHO 2023:42 formula:
             * ((pay roll start amount - expense - allowances - service fee) / (1 + social_percentage * 0.01)) * social_percentage * 0.01)
             */
            social_tax_value =
              ((inv_sum[i] - ser_cost[i] - expense[i] - allowance[i]) /
                (1 + standard_social_tax * 0.01)) *
              standard_social_tax *
              0.01
          } else if (0 < expense[i]) {
            social_tax_value =
              ((inv_sum[i] - ser_cost[i] - expense[i]) /
                (1 + standard_social_tax * 0.01)) *
              standard_social_tax *
              0.01
          } else if (0 < allowance[i]) {
            social_tax_value =
              ((inv_sum[i] - ser_cost[i] - allowance[i]) /
                (1 + standard_social_tax * 0.01)) *
              standard_social_tax *
              0.01
          } else {
            social_tax_value =
              ((inv_sum[i] - ser_cost[i]) / (1 + standard_social_tax * 0.01)) *
              standard_social_tax *
              0.01
          }

          // Ensure social tax is not negative
          social_tax_value = Math.max(
            0,
            Math.round(social_tax_value * 100) / 100
          )

          // Push the non-negative, rounded value into the social_tax array
          social_tax.push(social_tax_value)
        }
      }
      // console.log('huong social_tax [] >>>>>>>>>>>>>>>>>>>>>', social_tax)

      let social_contribution = social_tax.reduce((a, b) => a + b, 0)

      if (social_contribution <= 0) {
        social_contribution = 0
      }

      const palkka = state.selectedRows.map((el, index) => {
        if (state.newSalary[el].isGroupInvoice !== 1) {
          return Math.max(
            0,
            // Subtracting social contribution, service fee, allowance and expense (if there are some)
            // for gross salary §KHO 2023:42
            state.newSalary[el].sumInvWithTax -
              state.newSalary[el].sumInvVat -
              state.newSalary[el].suminvAllowVat -
              state.newSalary[el].expenses -
              state.newSalary[el].allowances -
              social_tax[index] -
              ser_cost[index]
          )
        } else {
          return Math.max(
            0,
            // KAS-553,554 When the selected is group invoice, take "sumVat" for calculation instead of "sumInvVat"
            state.newSalary[el].sumInvWithTax -
              state.newSalary[el].sumVat -
              state.newSalary[el].suminvAllowVat -
              state.newSalary[el].expenses -
              state.newSalary[el].allowances -
              social_tax[index] -
              ser_cost[index]
          )
        }
      })
      let palkka_sum = palkka.reduce((a, b) => a + b, 0)
      // Incase it's only Allowance or Expense 'palkka' will be negative
      if (palkka_sum <= 0) {
        palkka_sum = 0
      }

      const grossPerInvoice = []
      for (var i = 0; i < palkka.length; i++) {
        grossPerInvoice.push(palkka[i])
      }
      let gross_sum = grossPerInvoice.reduce((a, b) => a + b, 0)

      // let isAllowanceExpenseServiceCostHigherThanInvoiceItems =
      //   payRollStartAmount < service_cost && payRollStartAmount !== 0

      // Calculate allowance expense service exceed invoice items each invoice selected
      // then sum them later
      const allowanceExpenseExceedInvoiceItems_per_invoice = []
      for (
        var i = 0;
        i < payRollStartAmount_invoice_item_without_vat_per_invoice.length;
        i++
      ) {
        let allowanceExpenseExceedInvoiceItems_value = 0
        if (
          // Allowance Expense Service Cost Higher Than Invoice Items
          payRollStartAmount_invoice_item_without_vat_per_invoice[i] <
            ser_cost[i] &&
          payRollStartAmount_invoice_item_without_vat_per_invoice[i] !== 0
        ) {
          allowanceExpenseExceedInvoiceItems_value =
            ser_cost[i] -
            payRollStartAmount_invoice_item_without_vat_per_invoice[i]
        } else {
          allowanceExpenseExceedInvoiceItems_value = ser_cost[i]
        }
        allowanceExpenseExceedInvoiceItems_per_invoice.push(
          allowanceExpenseExceedInvoiceItems_value
        )
      }
      // console.log(
      //   'huong allowanceExpenseExceedInvoiceItems_per_invoice [] >>>>>>>>>>>>>>>>>>>>>>...',
      //   allowanceExpenseExceedInvoiceItems_per_invoice
      // )
      let allowanceExpenseExceedInvoiceItems =
        allowanceExpenseExceedInvoiceItems_per_invoice.reduce(
          (a, b) => a + b,
          0
        )

      if (gross_sum <= 0) {
        gross_sum = 0
        social_contribution = 0

        // This setup data for this palvelu to payRollStartAmount is move up.
        // This is the remaining service_cost amount
        // if (isAllowanceExpenseServiceCostHigherThanInvoiceItems) {
        //   palvelu_final = payRollStartAmount
        // }
      }

      let salary_sum = payRollStartAmount_invoice_item_without_vat
      salary_sum = Math.round(salary_sum * 100) / 100

      let yel = gross_sum * yel_percentage
      // console.log('huong yel >>>>>>>>>>>>>>>>>>>>>', yel)

      const total_sum = total_gross + gross_sum
      if (yel_option === 'yel_minimum') {
        if (yel_income <= 9010.28) {
          yel_income = 9010.28
        }
        let remaining_amt
        let min_yel_to_pay
        let earningReached
        if (total_sum > yel_income) {
          let sal_diff = yel_income - total_gross
          if (sal_diff >= 0) {
            remaining_amt = gross_sum - sal_diff
            min_yel_to_pay = 9010.28 * yel_percentage
            earningReached = (gross_sum - remaining_amt) / yel_income
            yel = min_yel_to_pay * earningReached
          } else {
            yel = 0
          }
        } else {
          min_yel_to_pay = 9010.28 * yel_percentage
          earningReached = gross_sum / yel_income
          yel = min_yel_to_pay * earningReached
        }
      }

      const prof_tax = state.selectedRows.map(
        (el) => state.newSalary[el].professionaltax
      )

      const insurance = []
      for (var i = 0; i < grossPerInvoice.length; i++) {
        insurance.push(
          grossPerInvoice[i] *
            prof_tax[i] *
            0.01 *
            STANDARD_VAT_CALCULATION_INDEX
        )
      }

      let accidental_insurance = insurance.reduce((a, b) => a + b, 0)

      if (accidental_insurance <= 0) {
        accidental_insurance = 0
      }

      const incomeLimit = salaryTaxPercent[0].incomeLimit
      const taxCardTotalGross = salaryTaxPercent[0].taxCardTotalGross
      const additionalPercentage =
        salaryTaxPercent[0].additionalPercentage * 0.01

      const brutto_gov_pay = brutto_ulosotto
        ? Math.round((gross_sum / 6) * 100) / 100
        : 0

      let personal_tax = gross_sum * personal_tax_percentage
      if (gross_sum + taxCardTotalGross > incomeLimit) {
        const incomeLeftBeforeLimit =
          incomeLimit - taxCardTotalGross < 0
            ? 0
            : incomeLimit - taxCardTotalGross
        const incomeAfterLimit =
          gross_sum - incomeLeftBeforeLimit < 0
            ? 0
            : gross_sum - incomeLeftBeforeLimit
        personal_tax =
          incomeLeftBeforeLimit * personal_tax_percentage +
          incomeAfterLimit * additionalPercentage
      }

      let net_sum = gross_sum - personal_tax - brutto_gov_pay
      net_sum = Math.round(net_sum * 100) / 100

      const normal_gov_pay = normal_ulosotto
        ? Math.round((net_sum / 3) * 100) / 100
        : 0

      if (yel_option === 'no_yel') {
        yel = 0
      }

      yel = Math.round(yel * 100) / 100
      service_cost = Math.round(service_cost * 100) / 100
      social_contribution = Math.round(social_contribution * 100) / 100
      accidental_insurance = Math.round(accidental_insurance * 100) / 100
      // Total Deductions without normal_gov_pay PI-177
      // Incase the allowance and expense adjusted service cost exceeds the invoice item vat 0 amount.
      // Need to correct the service cost here to take out invoice_items and the remaining sum is service_cost
      // const allowanceExpenseServiceCost =
      //   isAllowanceExpenseServiceCostHigherThanInvoiceItems
      //     ? allowanceExpenseExceedInvoiceItems
      //     : service_cost
      const allowanceExpenseServiceCost = allowanceExpenseExceedInvoiceItems

      // Using deductions sum to show the remaining service cost after subtracting invoiceItems amount vat 0.
      // Incase the service cost is greater than the invoiceItems amount vat 0.
      let deductions_sum =
        yel +
        allowanceExpenseServiceCost +
        social_contribution +
        accidental_insurance
      deductions_sum = Math.round(deductions_sum * 100) / 100
      // Calculate yelAccidental because social_contribution and service_cost is already subtracted
      let yelAccidental = yel + accidental_insurance
      yelAccidental = Math.round(yelAccidental * 100) / 100

      let expenses_cost_sum = expense.reduce((a, b) => a + b, 0)
      expenses_cost_sum = Math.round(expenses_cost_sum * 100) / 100

      let allowances_cost_sum = allowance.reduce((a, b) => a + b, 0)
      allowances_cost_sum = Math.round(allowances_cost_sum * 100) / 100

      // Separately calculate zero gross then sum them later
      // Incase gross was negative, subtract the service fee from net salary.
      // When it's allowance or expense items only.
      // When it's allowance or expense items where the combined service cost
      // exceeds the invoiceItems vat0 subtract invoiceItems.
      const zero_gross_service_fee_per_invoice = []
      for (var i = 0; i < payRollStartAmount_value.length; i++) {
        let zero_gross_service_fee_per_invoice_value
        if (
          payRollStartAmount_value[i] < ser_cost[i] &&
          payRollStartAmount_value[i] !== 0 &&
          !discount
        ) {
          zero_gross_service_fee_per_invoice_value =
            ser_cost[i] - payRollStartAmount_value[i]
        } else if (
          payRollStartAmount_invoice_item_without_vat_per_invoice[i] === 0 &&
          !discount
        ) {
          zero_gross_service_fee_per_invoice_value = ser_cost[i]
        } else {
          zero_gross_service_fee_per_invoice_value = 0
        }
        zero_gross_service_fee_per_invoice.push(
          zero_gross_service_fee_per_invoice_value
        )
      }

      // console.log(
      //   'huong zero_gross_service_fee_per_invoice [] >>>>>>>>>>>>>>>>>>>>>>...',
      //   zero_gross_service_fee_per_invoice
      // )

      let zero_gross_service_fee = zero_gross_service_fee_per_invoice.reduce(
        (a, b) => a + b,
        0
      )

      // Incase gross was negative, subtract the service fee from net salary.
      // When it's allowance or expense items only.
      // When it's allowance or expense items where the combined service cost
      // exceeds the invoiceItems vat0 subtract invoiceItems.
      // let zero_gross_service_fee = 0
      // // Referal needs to set service_cost to 0
      // if (isAllowanceExpenseServiceCostHigherThanInvoiceItems && !discount) {
      //   zero_gross_service_fee = service_cost - payRollStartAmount
      // } else if (payRollStartAmount === 0 && !discount) {
      //   zero_gross_service_fee = service_cost
      // } else {
      //   zero_gross_service_fee = 0
      // }
      //paid_sum without normal_gov_pay
      let paid_sum =
        net_sum -
        yelAccidental -
        normal_gov_pay +
        allowances_cost_sum +
        expenses_cost_sum -
        zero_gross_service_fee

      paid_sum = Math.round(paid_sum * 100) / 100
      // KAS 336 show dialog
      let showDialog
      if (
        state.willGetDiscount === true &&
        state.recommendedPersonGetDiscount === false
      ) {
        // show dialog only when the code is not sent
        showDialog = true
      } else {
        showDialog = false
      }
      // KAS-375 check code is activated to show dialog
      let isCodeActivated
      if (
        state.willGetDiscount === true &&
        state.recommendedPersonGetDiscount === true
      ) {
        isCodeActivated = true
      } else {
        isCodeActivated = false
      }

      return Object.assign(
        {},
        { ...state },
        {
          salaryAllowances: action.result,
          newSalarySummary: {
            sumInvWithoutTax: payRollStartAmount_invoice_item_without_vat,
            sumWithTax: sumWithTaxComb,
            service_cost: service_cost,
            palvelu: palvelu_final,
            quick_pay_cost: pikapalkka_final,
            salary_sum: salary_sum,
            gross_sum: gross_sum,
            net_sum: net_sum,
            isnormalgovpay: normal_ulosotto,
            isbruttogovpay: brutto_ulosotto,
            normal_ulosotto_sum: normal_gov_pay,
            brutto_ulosotto_sum: brutto_gov_pay,
            allowances_cost: allowances_cost_sum,
            expenses_cost: expenses_cost_sum,
            expense_cost_with_vat: expense_cost_with_vat,
            expense_cost_without_vat: expense_cost_without_vat,
            paid_sum: paid_sum,
            social_contri: social_contribution,
            yel_insurance: yel,
            tax_percentage: personal_tax,
            acc_insurance: accidental_insurance,
            palkka: palkka_sum,
            deductions_sum: deductions_sum,
            status: inv_status,
            instant_payment: inst_pay,
            isPartial: inv_partialStatus,
            isGroupInvoice: group_invoice
          },
          salaryTaxPercentage: salaryTaxPercent,
          discount: discount,
          showDialog: showDialog,
          isCodeActivated: isCodeActivated
        }
      )

    // KAS-336 Get referral discount by email
    case GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS:
      const result = action.data
      const allSalaries = state.allSalaries
      let willGetDiscount
      let recommendedPersonGetDiscount
      let referrerPersonGetDiscount
      if (
        result === 'Recommended email is not activated the referral code' &&
        allSalaries.length <= 4
      ) {
        willGetDiscount = true
        recommendedPersonGetDiscount = false
        referrerPersonGetDiscount = false
      } else if (
        result === 'Recommended email is activated the referral code'
      ) {
        willGetDiscount = true
        recommendedPersonGetDiscount = true
        referrerPersonGetDiscount = false
      } else if (
        result === 'Referral email is eligible for the referral discount'
      ) {
        willGetDiscount = false
        recommendedPersonGetDiscount = false
        referrerPersonGetDiscount = true
      } else {
        willGetDiscount = false
        recommendedPersonGetDiscount = false
        referrerPersonGetDiscount = false
      }

      return Object.assign(
        {},
        { ...state },
        {
          willGetDiscount: willGetDiscount,
          recommendedPersonGetDiscount: recommendedPersonGetDiscount,
          referrerPersonGetDiscount: referrerPersonGetDiscount,
          accountStatus: result
        }
      )

    case CLOSE_DIALOG_SALARY:
      return Object.assign(
        {},
        { ...state },
        {
          showDialog: false,
          isCodeActivated: false
        }
      )

    case SEND_REFERRAL_CODE_SUCCESS:
      const resultData = action.data
      // let newSalarySummary = state.newSalarySummary
      let sendCodeSuccess, nerverUseDiscount, discount_after_send_code
      if (resultData === 'Referral program information updated successfully') {
        sendCodeSuccess = true
        discount_after_send_code = true
        nerverUseDiscount = false

        // KAS-336 Calculation after discount applied
        //Need to remove this calculation since new salary calculation is updated
        // newSalarySummary.deductions_sum =
        //   newSalarySummary.deductions_sum - newSalarySummary.service_cost
        // newSalarySummary.paid_sum =
        //   newSalarySummary.paid_sum + newSalarySummary.service_cost
        // newSalarySummary.salary_sum =
        //   newSalarySummary.salary_sum + newSalarySummary.service_cost
        // newSalarySummary.palvelu = 0
        // newSalarySummary.service_cost = 0
      } else if (
        resultData === 'Recommended person denied the referral program'
      ) {
        sendCodeSuccess = false
        discount_after_send_code = false
        nerverUseDiscount = true
      }

      return Object.assign(
        {},
        { ...state },
        {
          showDialog: false,
          sendCodeSuccess: sendCodeSuccess,
          nerverUseDiscount: nerverUseDiscount,
          sendCodeFailed: false,
          discount: discount_after_send_code
          // newSalarySummary: newSalarySummary
        }
      )
    case SEND_REFERRAL_CODE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showDialog: true,
          sendCodeSuccess: false,
          sendCodeFailed: true
        }
      )

    case CLOSE_SALARY_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          sendCodeSuccess: false,
          sendCodeFailed: false,
          nerverUseDiscount: false
        }
      )

    case CLEAR_SELECTED_USER:
      return Object.assign(
        {},
        { ...state },
        {
          allSalaries: []
        }
      )

    default:
      return state
  }
}

const _createSalaryRows = (allSalaries, selected) =>
  allSalaries.slice(selected * 10, selected * 10 + 10).map((el, index) => (
    <SalaryRow
      index={index}
      key={el.id}
      date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.created))}
      invoice_id={el.invoices}
      invoice_sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.sumWithTax)}
      gross_sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.gross_salary)}
      net_sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.take_home_pay)}
      allowance_cost={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.expenses_cost)}
      expense_cost={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.reimbursment_cost)}
      status={convertNameToState(el.status)}
      id={el.id}
      invoice_uuid={el.invoice_uuid}
    />
  ))

const _handleSalaryRowClick = (id, selectedRows) => {
  let salaryRowSelected = selectedRows
  let selectedIndex = salaryRowSelected.indexOf(id)

  //console.log('Inside _handleSalaryRowClick selectedIndex:: ',selectedIndex)

  let newSelected = []

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(salaryRowSelected, id)
    //console.log('Inside _handleSalaryRowClick selectedIndex1:: ',selectedIndex)
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(salaryRowSelected.slice(1))
    //console.log('Inside _handleSalaryRowClick selectedIndex2:: ',selectedIndex)
  } else if (selectedIndex === salaryRowSelected.length - 1) {
    newSelected = newSelected.concat(salaryRowSelected.slice(0, -1))
    //console.log('Inside _handleSalaryRowClick selectedIndex3:: ',selectedIndex)
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      salaryRowSelected.slice(0, selectedIndex),
      salaryRowSelected.slice(selectedIndex + 1)
      //console.log('Inside _handleSalaryRowClick selectedIndex4:: ',selectedIndex)
    )
  }

  //console.log('Inside _handleSalaryRowClick newSelected:: ',newSelected)

  salaryRowSelected = newSelected

  //console.log('Inside _handleSalaryRowClick salaryRowSelected:: ',salaryRowSelected)

  return salaryRowSelected
}

export default salaryReducer
